import { render, staticRenderFns } from "./OrderReportListMobile.vue?vue&type=template&id=088b2e18"
import script from "./OrderReportListMobile.vue?vue&type=script&lang=ts"
export * from "./OrderReportListMobile.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../qraved-ordering-backoffice/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports